<template>
  <cld-image
      v-if="team"
      :publicId="'/sandkastenliga/realteams/' + teamId"
      :width="height"
      :height="height"
      crop="fill"
      dpr="auto"
      responsive="true"
      class="d-inline-flex"
      :style="{maxWidth: height + 'px'}"
  />
</template>

<script>

export default {
  props: {
    team: String,
    height: {
      default: 28,
      type: Number
    }
  },
  data() {
    return {
      notFound: false
    };
  },
  computed: {
    teamId() {
      if (this.notFound) {
        return 'fallback_realteam_emblem'
      }
      let id = '';
      for (let c of this.team.toLowerCase()) {
        if (this.isLetterOrDigit(c)) {
          id += c;
        } else {
          id += '_';
        }
      }
      return id;
    },
    svgUrl() {
      return 'https://res.cloudinary.com/sandkastenliga/image/upload/c_pad,h_' + this.height
          + ',w_' + this.height
          + '/sandkastenliga/realteams/'
          + (this.notFound ? 'fallback_realteam_emblem' : this.teamId) + '.png';
    }
  },
  methods: {
    isLetterOrDigit(lowerCaseChar) {
      return ('0123456789abcdefghijklmnopqrstuvwxyz'.includes(lowerCaseChar));
    }
  }
}
</script>
